import script from "./ModalComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalComponent.vue?vue&type=script&setup=true&lang=js"

import "./ModalComponent.vue?vue&type=style&index=0&id=2d8bb2c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d8bb2c5"]])

export default __exports__